import { styled } from 'styled-components'
import { PlusIcon } from '../../../icons'

export const Row = styled.div`
  padding: 4px 20px 24px;
`

export const AddProductButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  line-height: 135%;
  color: ${({ theme }) => theme.colors.black};
  text-decoration: underline;
  text-decoration-skip-ink: none;
  text-underline-position: from-font;
  -webkit-tap-highlight-color: transparent;
`

export const Plus = styled(PlusIcon)`
  flex-shrink: 0;
  width: 9px;
  height: 9px;
`
